
export const isError = action =>
  (action.error || action.payload instanceof Error);

const errorHandler = store => next => (action) => {
  if (isError(action)) {
    console.error(action.payload);
    // Disable generic error handling, do this in action generators explicitly!
    // return next(handleError(store.dispatch)(action.payload));
  }
  return next(action);
};

export default errorHandler;



// WEBPACK FOOTER //
// ./src/middleware/errorHandler.js